import z from 'zod';

const feeSchema = z.object({
  amount: z.number(),
});

export const creditActivatedProductSchema = z.object({
  agreementId: z.string(),
  creditLimit: z.number(),
  annualInterest: z.number(),
  effectiveInterest: z.number(),
  amountUsed: z.number(),
  monthlyPayment: z.number(),
  numberOfRemainingInstallments: z.number(),
  // TODO(EC-1143): Make this required once the backend is updated
  remainingRepayableAmount: z.number().optional(),
  nextChargeDate: z.string().optional(),
  fees: z.object({
    setupFee: feeSchema.optional(),
    withdrawalFee: feeSchema.optional(),
    installmentFee: feeSchema.optional(),
    directDebitMissingFee: feeSchema.optional(),
  }),
  minimumWithdrawalAmount: z.number(),
});

export const debtConsolidationActivatedProductSchema = z.object({
  agreementId: z.string(),
  creditLimit: z.number(),
  annualInterest: z.number(),
  effectiveInterest: z.number(),
  amountUsed: z.number(),
  monthlyPayment: z.number(),
  numberOfRemainingInstallments: z.number(),
  // TODO(EC-1143): Make this required once the backend is updated
  remainingRepayableAmount: z.number().optional(),
  nextChargeDate: z.string().optional(),
  fees: z.object({
    setupFee: feeSchema.optional(),
    withdrawalFee: feeSchema.optional(),
    installmentFee: feeSchema.optional(),
    directDebitMissingFee: feeSchema.optional(),
  }),
});

const loanBaseSchema = z.object({
  agreementId: z.string(),
  loanAmount: z.number(),
  amountUsed: z.number(),
  annualInterest: z.number(),
  effectiveInterest: z.number(),
  monthlyPayment: z.number(),
  numberOfRemainingInstallments: z.number(),
  // TODO(EC-1143): Make this required once the backend is updated
  remainingRepayableAmount: z.number().optional(),
  nextChargeDate: z.string().optional(),
  fees: z.object({
    setupFee: feeSchema.optional(),
    installmentFee: feeSchema.optional(),
    directDebitMissingFee: feeSchema.optional(),
  }),
});

export const loanActivatedProductSchema = z.discriminatedUnion('productVariant', [
  z.object({ ...loanBaseSchema.shape, productVariant: z.literal('LOAN') }),
  z.object({ ...loanBaseSchema.shape, productVariant: z.literal('LOAN_ID_PROTECT') }),
  z.object({
    ...loanBaseSchema.shape,
    productVariant: z.literal('LOAN_PARTNER'),
    partnerId: z.literal('HOMESAFE'),
    productName: z.enum(['PREMIUM', 'PLUS', 'BASE']),
  }),
]);

const meResponseBaseSchema = z.object({
  id: z.string(),
  email: z.string(),
  mobile: z.string(),
  firstName: z.string().optional(),
  givenName: z.string(),
  lastName: z.string(),
  emailStatus: z.enum(['VERIFIED', 'NOT_VERIFIED', 'INVALID']),
  mobileStatus: z.enum(['VERIFIED', 'NOT_VERIFIED']),
});

export const meResponseSESchema = z.object({
  ...meResponseBaseSchema.shape,
  nationalNumber: z.string(),
  paymentProvider: z.enum(['Trustly', 'Zimpler']),
  country: z.literal('SE'),
  activatedProducts: z.object({
    credit: creditActivatedProductSchema.optional(),
    debtConsolidation: debtConsolidationActivatedProductSchema.optional(),
    loan: loanActivatedProductSchema.optional(),
  }),
});

export const meResponseUKSchema = z.object({
  ...meResponseBaseSchema.shape,
  paymentProvider: z.literal('Modulr'),
  country: z.literal('UK'),
  activatedProducts: z.object({
    credit: creditActivatedProductSchema,
  }),
});

export const meResponseFISchema = z.object({
  ...meResponseBaseSchema.shape,
  country: z.literal('FI'),
  businessId: z.string(),
  businessName: z.string(),
  activatedProducts: z.object({
    credit: creditActivatedProductSchema,
  }),
});

export const getFinancialDetailsResponseSchema = z.object({
  kaMonthlyHouseCost: z.number(),
  kaNumberOfChildren: z.number(),
  kaNumberOfPersonsLiving: z.number(),
  kaOtherLoanCost: z.number(),
  monthlyGrossIncome: z.number().optional(),
  transportationCost: z.number().optional(),
});

export const updateFinancialDetailsResponseSchema = getFinancialDetailsResponseSchema.required();
